import React from 'react';
import PropTypes from 'prop-types';
import {
  Select, Option, FormControl, InputLabel,
}
from '@fuww/library/src/SelectMenus';
import { SelectMenuContainer } from '@fuww/library/src/Layouts/CoursesPage';
import withQuery from '../../lib/withQuery';

const label = 'Category';

const CategorySelect = ({
  data: {
    courseCategories,
  }, value, handleOnChange, className,
}) => (
  <SelectMenuContainer>
    <FormControl
      variant="outlined"
      fullWidth
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={handleOnChange}
        className={className}
      >
        {
      courseCategories.map(({ id, title }) => (
        <Option
          key={id}
          value={id}
        >
          {title}
        </Option>
      ))
    }
      </Select>
    </FormControl>
  </SelectMenuContainer>
);

CategorySelect.propTypes = {
  data: PropTypes.shape({
    courseCategories: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  handleOnChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  className: PropTypes.string,
};

CategorySelect.defaultProps = {
  data: {},
  value: null,
  className: null,
};

export default withQuery(CategorySelect);
